import StackedArray from '@/utils/StackedArray';

export const Features = {
    DEVSERVER: 'devserver',
    PWA: 'PWA',
    BUGSNAG: 'bugsnag',
    CORDOVA: 'cordova',
};

export default StackedArray.get(process.env.NODE_ENV, [
    [
        'development',
        {
            features: [Features.DEVSERVER],
        },
    ],
    [
        'production',
        {
            features: [Features.PWA, Features.BUGSNAG],
        },
    ],
]);
